import { render, staticRenderFns } from "./Pause.vue?vue&type=template&id=ef42060e&scoped=true&"
import script from "./Pause.vue?vue&type=script&lang=js&"
export * from "./Pause.vue?vue&type=script&lang=js&"
import style0 from "./Pause.vue?vue&type=style&index=0&id=ef42060e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef42060e",
  null
  
)

export default component.exports